export default "/images/share.svg?e796fa0c01681ff748dfe8265685d8e8";